import React, { useState } from "react";
import "./HomeLayout.css";

const WhyChooseSection = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleReadMore = () => setIsExpanded(!isExpanded);

  return (
    <section className="home-section home-section--muted">
      <div className="container">
        <div className="home-section-title text-start">
          <h2 className="home-section-heading">Why Choose Angel Gulf Jobs?</h2>
        </div>
        <div style={{ fontSize: "1.05rem", lineHeight: "1.9", color: "#424d5c" }}>
          <div className={`intro-collapsible-content ${isExpanded ? "expanded" : ""}`}>
            <p>
              Over the years, Angel Gulf Jobs has built a strong reputation as one of the most trusted Gulf recruitment
              consultants in Mumbai. Our recruitment agency offers professional, ethical, and result-driven services as a
              Gulf job consultancy in India. Whether employers need bulk staffing or specialised professionals, our
              international recruitment expertise ensures reliable outcomes. As a seasoned overseas job placement agency, we
              have supported thousands of candidates in securing long-term employment in the Gulf.
            </p>
            <p>
              Our success is driven by a dedicated approach, a large database of job seekers, and an in-depth understanding
              of Gulf job markets. We follow a transparent recruitment process aligned with Gulf labour laws, ensuring that
              both job seekers and employers benefit from accurate information, fair guidelines, and ethical employment
              practices. This commitment has positioned us as the best Gulf job consultancy for organisations needing
              consistent staffing support.
            </p>
            <p>
              Backed by a proven track record and a commitment to ethical recruitment standards, Angel Gulf Jobs remains the
              preferred hiring partner for leading companies across the Gulf region. Our manpower consultancy offers
              high-quality workforce solutions that empower businesses and help job seekers achieve rewarding, long-term
              overseas careers.
            </p>
          </div>
          <button className="intro-read-more-btn" onClick={toggleReadMore}>
            {isExpanded ? "Read Less" : "Read More"}
          </button>
        </div>
      </div>
    </section>

    // <section className="why-choose-section">
    //   <div className="container">
    //     <div className="row align-items-center">

    //       {/* Left Image */}
    //       <div className="col-lg-5 mb-lg-0">
    //         <div className="why-image-wrapper">
    //           <img
    //             src="/images/blog/latest/bg12.jpg"
    //             alt="Angel Gulf Jobs"
    //             className="img-fluid why-image"
    //           />

    //           <div className="experience-badge">
    //             <h3>15+</h3>
    //             <span>Years of Excellence</span>
    //           </div>
    //         </div>
    //       </div>

    //       {/* Right Content */}
    //       <div className="col-lg-7">
    //         <div className="why-content">
    //           <h2>
    //             Why choose Angel Gulf Jobs ?
    //           </h2>

    //           <p>
    //             Over the years, Angel Gulf Jobs has built a strong reputation as one of the most trusted Gulf recruitment
    //             consultants in Mumbai. Our recruitment agency offers professional, ethical, and result-driven services as a
    //             Gulf job consultancy in India. Whether employers need bulk staffing or specialised professionals, our
    //             international recruitment expertise ensures reliable outcomes. As a seasoned overseas job placement agency, we
    //             have supported thousands of candidates in securing long-term employment in the Gulf.
    //         </p>
    //         <p>
    //           Our success is driven by a dedicated approach, a large database of job seekers, and an in-depth understanding
    //           of Gulf job markets. We follow a transparent recruitment process aligned with Gulf labour laws, ensuring that
    //           both job seekers and employers benefit from accurate information, fair guidelines, and ethical employment
    //           practices. This commitment has positioned us as the best Gulf job consultancy for organisations needing
    //           consistent staffing support.
    //         </p>
    //         <p>
    //           Backed by a proven track record and a commitment to ethical recruitment standards, Angel Gulf Jobs remains the
    //           preferred hiring partner for leading companies across the Gulf region. Our manpower consultancy offers
    //           high-quality workforce solutions that empower businesses and help job seekers achieve rewarding, long-term
    //           overseas careers.
    //         </p>

    //           {/* <div className="feature-list">

    //             <div className="feature-item">
    //               <div className="feature-icon">
    //                 <i className="fas fa-globe"></i>
    //               </div>

    //               <div>
    //                 <h5>Strong Gulf Network</h5>
    //                 <p>
    //                   Trusted hiring partner for leading companies across
    //                   the Gulf region.
    //                 </p>
    //               </div>
    //             </div>

    //             <div className="feature-item">
    //               <div className="feature-icon">
    //                 <i className="fas fa-user-check"></i>
    //               </div>

    //               <div>
    //                 <h5>Ethical Recruitment</h5>
    //                 <p>
    //                   Transparent hiring process aligned with Gulf labour laws
    //                   and international standards.
    //                 </p>
    //               </div>
    //             </div>

    //             <div className="feature-item">
    //               <div className="feature-icon">
    //                 <i className="fas fa-briefcase"></i>
    //               </div>

    //               <div>
    //                 <h5>Proven Placement Success</h5>
    //                 <p>
    //                   Helping job seekers secure rewarding overseas careers
    //                   while supporting business growth.
    //                 </p>
    //               </div>
    //             </div>

    //           </div>

    //           <a href="/contact" className="why-btn">
    //             Contact Our Team
    //           </a> */}

    //         </div>
    //       </div>

    //     </div>
    //   </div>
    // </section>
  );
};

export default WhyChooseSection;

